import type { SubScene } from "@/api/solutionApi";

interface Props {
  scene: SubScene;
}

export default function DetailBenefits({ scene }: Props) {
  const count = scene.benefits.length;
  // 每行展示数量：≤4个时单行展示；5-6个每行3个；7-8个每行4个
  const perRow = count <= 4 ? Math.max(count, 1) : count <= 6 ? 3 : 4;
  // 每张卡片基准宽度：保证每行恰好 perRow 个，剩余不满一行的卡片通过 justify-center 居中
  const cardBasis = `calc((100% - ${(perRow - 1)} * 1rem) / ${perRow})`;

  return (
    <section
      className="py-16 lg:py-20"
      style={{ background: `linear-gradient(160deg, #1e2d45 0%, #2a3a52 60%, ${scene.accentColor}18 100%)` }}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Section header */}
        <div className="text-center mb-12">
          <div
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-4 border"
            style={{ borderColor: `${scene.accentColor}40`, backgroundColor: `${scene.accentColor}15` }}
          >
            <i className="ri-star-line text-xs" style={{ color: scene.accentColor }}></i>
            <span className="text-xs font-semibold tracking-wider" style={{ color: scene.accentColor }}>
              Value Summary
            </span>
          </div>
          <h2 className="text-2xl lg:text-3xl font-bold text-white mb-3">方案价值总结</h2>
          <p className="text-white/50 text-sm max-w-lg mx-auto">
            选择我们的{scene.name}，获得可量化的业务价值提升
          </p>
        </div>

        {/* Benefits grid：弹性布局，不满一行时居中展示 */}
        <div className="flex flex-wrap justify-center gap-4">
          {scene.benefits.map((benefit, index) => (
            <div
              key={benefit.title}
              className="group flex flex-col gap-4 px-8 py-10 rounded-2xl transition-all duration-300 cursor-default"
              style={{
                backgroundColor: "rgba(22,34,54,0.55)",
                border: `1px solid ${scene.accentColor}20`,
                flexBasis: cardBasis,
                minWidth: "240px",
                maxWidth: "100%",
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLDivElement).style.backgroundColor = `${scene.accentColor}25`;
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLDivElement).style.backgroundColor = "rgba(22,34,54,0.55)";
              }}
            >
              <span
                className="text-xs font-bold tracking-widest"
                style={{ color: `${scene.accentColor}60` }}
              >
                {String(index + 1).padStart(2, "0")}
              </span>
              <div
                className="w-14 h-14 flex items-center justify-center rounded-2xl transition-transform duration-300 group-hover:scale-110"
                style={{
                  backgroundColor: `${scene.accentColor}20`,
                  border: `1px solid ${scene.accentColor}35`,
                }}
              >
                <i className={`${benefit.icon} text-2xl`} style={{ color: scene.accentColor }}></i>
              </div>
              <div className="text-3xl font-extrabold text-white">{benefit.value}</div>
              <div>
                <h4 className="text-base font-bold text-white mb-2">{benefit.title}</h4>
                <p className="text-sm text-white/55 leading-relaxed">{benefit.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
